<template>
  <div id="app">
  <!-- Sidebar -->
  <div id="wrapper" v-bind:class="{ toggled: isSideBarVisible }">
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav">
            <li class="sidebar-brand">
                <a href="#">
                    
                </a>
            </li>
            <li>
                Exercices
            </li>
            <li>
                <a href="#" v-on:click.prevent="$refs.childApplication.showAddExerciceModal()"><span class="fa fa-plus fa-lg"></span></a>
            </li>
            <li>
                <a href="#" v-on:click.prevent="$refs.childApplication.showRemoveExerciceModal()"><span class="fa fa-minus fa-lg"></span></a>
            </li>
            <li>
                <a href="#" v-on:click.prevent="$refs.childApplication.toggleAllExercices()"><span class="fa fa-sort-up fa-lg"></span></a>
            </li>
            <li>
                &nbsp;
            </li>
            <li>
                <a href="#">Parties</a>
            </li>
            <li>
                <a href="#" v-on:click.prevent="$refs.childApplication.showAddPartModal()"><span class="fa fa-plus fa-lg"></span></a>
            </li>
            <li>
                <a href="#" v-on:click.prevent="$refs.childApplication.showRemovePartModal()"><span class="fa fa-minus fa-lg"></span></a>
            </li>
            <li>
                &nbsp;
            </li>
            <li>
               <a href="#">Objectifs </a>
            </li>
            <li>
            <a href="#" v-on:click.prevent="$refs.childApplication.howManyObjectivesToAdd()"><span class="fa fa-plus fa-lg"></span></a>
        </li>
        <li>
            <a href="#" v-on:click.prevent="$refs.childApplication.showRemoveObjectiveModal()"><span class="fa fa-minus fa-lg"></span></a>
        </li>
        </ul>
    </div>

 <div id="page-content-wrapper" style="padding-left:20px;">
    <div v-if="this.isAuthenticated" class="mb-3">
      <b-navbar toggleable="md" type="dark" variant="evaobj">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      
        <b-navbar-brand href="#">EvaObj - Évaluation par objectifs</b-navbar-brand>
        <b-collapse is-nav id="nav_collapse">
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="#" v-on:click="back()" v-if="this.isAuthenticated && ($route.path.indexOf('testEdit') !== -1 || $route.path.indexOf('results') !== -1 || $route.path.indexOf('bareme') !== -1)"><span class="fa fa-long-arrow-left fa-lg"></span> {{ $t('LNG_BACK', lang) }}</b-nav-item>
            
            <b-nav-item href="#" v-on:click="back()" v-if="this.isAuthenticated && ($route.path.indexOf('managementStudentsGroups') !== -1 || $route.path.indexOf('ManagementCenter') !== -1 || $route.path.indexOf('ManagementDiscipline') !== -1 || $route.path.indexOf('managementTeacher') !== -1) "><span class="fa fa-long-arrow-left fa-lg"></span> {{ $t('LNG_BACK', lang) }}</b-nav-item>
            <b-nav-item href="#" v-on:click="addStudent()" v-if="this.isAuthenticated && ($route.path.indexOf('managementStudentsGroups') !== -1)"><span class="fa fa-user fa-lg"></span> {{ $t('LNG_ADD_STUDENT', lang) }}</b-nav-item>
            <b-nav-item href="#" v-on:click="showAddTest()" v-if="this.isAuthenticated && ($route.path.indexOf('mainview') !== -1) && this.adminLevel < 2"><span class="fa fa-file fa-lg"></span> {{ $t('LNG_ADD_TEST', lang) }}</b-nav-item>
            <b-nav-item href="#" v-on:click="addCenter()" v-if="this.isAuthenticated && ($route.path.indexOf('ManagementCenter') !== -1) && this.adminLevel >= 4"><span class="fa fa-building-o fa-lg"></span> {{ $t('LNG_NEW_CENTER', lang) }}</b-nav-item>
            <b-nav-item href="#" v-on:click="addDiscipline()" v-if="this.isAuthenticated && ($route.path.indexOf('ManagementDiscipline') !== -1)"><span class="fa fa-comment-o fa-lg"></span> {{ $t('LNG_NEW_DISCIPLINE', lang) }}</b-nav-item>
            <b-nav-item href="#" v-on:click="addTeacher()" v-if="this.isAuthenticated && ($route.path.indexOf('managementTeacher') !== -1)"><span class="fa fa-address-card fa-lg"></span> {{ $t('LNG_NEW_TEACHER', lang) }}</b-nav-item>
          
            <b-nav-item-dropdown :text="$t('LNG_TEST_MANAGEMENT', this.lang)" v-if="this.$route.params.testId >= 1 && $route.path.indexOf('test') !== -1" right>
              <b-dropdown-item href="#" v-on:click="uploadFile()"><span class="fa fa-upload fa-lg"></span> {{ $t('LNG_UPLOAD', lang) }}</b-dropdown-item>
              <b-dropdown-item href="#" v-on:click="importObjectives()"><span class="fa fa-shopping-cart fa-lg"></span> {{ $t('LNG_IMPORT_OBJECTIVES', lang) }}</b-dropdown-item>
              <b-dropdown-item v-if="false" href="#" v-on:click="gotoKnowledgeManagement()"><span class="fa fa-lightbulb-o fa-lg"></span> {{ $t('LNG_MANAGE_KNOWLEDGE', lang) }}</b-dropdown-item>
              <b-dropdown-item href="#" v-on:click="enterResultsMenu()"><span class="fa fa-signal fa-lg"></span> {{ $t('LNG_NOTES', lang) }}</b-dropdown-item>
              <b-dropdown-item href="#" v-on:click="enterBaremeMenu()"><span class="fa fa-balance-scale fa-lg"></span> {{ $t('LNG_BAREME', lang) }}</b-dropdown-item>
              <b-dropdown-item  v-if="$route.path.indexOf('test') !== -1" href="#" v-on:click="printReport()"><span class="fa fa-print fa-lg"></span> {{ $t('LNG_PRINT_RESULTS', lang) }}</b-dropdown-item>
              <b-dropdown-item  v-if="$route.path.indexOf('test') !== -1" href="#" v-on:click="printComments()"><span class="fa fa-print fa-lg"></span> {{ $t('LNG_PRINT_COMMENTS', lang) }}</b-dropdown-item>
              <b-dropdown-item  v-if="$route.path.indexOf('test') !== -1" href="#" v-on:click="printStudentGrade()"><span class="fa fa-print fa-lg"></span> {{ $t('LNG_STUDENT_GRADE', lang) }}</b-dropdown-item>
              <b-dropdown-item  v-if="$route.path.indexOf('test') !== -1" href="#" v-on:click="printGroupFormation()"><span class="fa fa-print fa-lg"></span> {{ $t('LNG_PRINT_GROUPE_FORMATION', lang) }}</b-dropdown-item>
            </b-nav-item-dropdown>
            
            <b-nav-item-dropdown :text="$t('LNG_STUDENTS_MANAGEMENT', this.lang)" v-if="this.isAuthenticated && $route.path.indexOf('mainview') !== -1 && this.adminLevel < 4" right>
              <b-dropdown-item href="#" v-on:click="gotoShowModal()"><span class="fa fa-graduation-cap fa-lg"></span> {{ $t('LNG_STUDENTS', lang) }}</b-dropdown-item>
              <b-dropdown-item href="#" v-on:click="gotoStudentManagement()"><span class="fa fa-user fa-lg"></span> {{ $t('LNG_STUDENTS_MANAGEMENT', lang) }}</b-dropdown-item>
            </b-nav-item-dropdown>
            
            <b-nav-item-dropdown :text="$t('LNG_ADMINISTRATION', this.lang)" v-if="this.isAuthenticated && this.adminLevel >= 2" right>
              <b-dropdown-item v-if="this.adminLevel & 2 || (this.adminLevel & 4)" href="#" v-on:click="gotoManagementCenter()"><span class="fa fa-building-o fa-lg"></span> {{ $t('LNG_CENTER_MANAGEMENT', lang) }}</b-dropdown-item>
              <b-dropdown-item v-if="(this.adminLevel & 2) || (this.adminLevel & 4)" href="#" v-on:click="gotoManagementTeacher()"><span class="fa fa-address-card fa-lg"></span> {{ $t('LNG_TEACHER_MANAGEMENT', lang) }}</b-dropdown-item>
              <b-dropdown-item v-if="(this.adminLevel & 2) || (this.adminLevel & 4)" href="#" v-on:click="gotoManagementDiscipline()"><span class="fa fa-comment-o fa-lg"></span> {{ $t('LNG_DISCIPLINE_MANAGEMENT', lang) }}</b-dropdown-item>
            </b-nav-item-dropdown>
            
            <b-nav-item-dropdown :text="this.fullname" v-if="this.isAuthenticated" right>
              <b-dropdown-item href="#/changePassword"><span class="fa fa-lock fa-lg"></span> {{ $t('LNG_CHANGE_PASSWORD_BTN', lang) }}</b-dropdown-item>
              <b-dropdown-item href="#" v-on:click="logout()"><span class="fa fa-sign-out fa-lg"></span> {{ $t('LNG_LOGOUT_BTN', lang) }}</b-dropdown-item>
              <b-dropdown-item href="#" >{{ $t('LNG_VERSION', lang) }}</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item href="#" v-on:click="support()"><span class="fa fa-question-circle fa-lg"></span> {{ $t('LNG_HELP', lang) }}</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div>
      <router-view ref="childApplication"></router-view>
    </div>
    <div>
      <spinner ref="spinner" v-show="spinner" global size="50" line-fg-color="#97002D" :speed=3 :line-size=5></spinner>
    </div>
  </div>
  </div>
  </div>
</template>




<script>
import { mapState } from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import spinner from 'vue-simple-spinner'
export default {
  name: 'app',
  components: {
    BootstrapVue,
    spinner
  },
  data () {
    return {
      spinner: false,
      isSideBarVisible: false,
      tableTexts: {
        count: this.$t('LNG_TABLE_COUNT', this.lang),
        filter: this.$t('LNG_TABLE_FILTER', this.lang),
        filterPlaceholder: this.$t('LNG_TABLE_FILTERPLACEHOLDER', this.lang),
        limit: this.$t('LNG_TABLE_LIMIT', this.lang),
        noResults: this.$t('LNG_TABLE_NORESULTS', this.lang),
        page: this.$t('LNG_TABLE_PAGE', this.lang),
        filterBy: this.$t('LNG_TABLE_FILTERBY', this.lang),
        loading: this.$t('LNG_TABLE_LOADING', this.lang),
        defaultOption: this.$t('LNG_TABLE_DEFAULTOPTION', this.lang)
      }
    }
  },
  mounted () {
    this.$store.commit('UPDATE_TITLE', this.$t('LNG_TITLE', this.lang))
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    adminLevel () {
      return this.$store.getters.adminLevel
    },
    ...mapState([
      'api',
      'lang',
      'title',
      'fullname'
    ])
  },
  methods: {
    logout () {
      this.$store.commit('LOGOUT')
      this.$router.push({ path: '/' })
    },
    gotoManagementTeacher: function () {
      this.$router.push({ path: '/managementTeacher' })
    },
    gotoManagementDiscipline: function () {
      this.$router.push({ path: '/ManagementDiscipline' })
    },
    gotoManagementCenter: function () {
      this.$router.push({ path: '/ManagementCenter' })
    },
    gotoShowModal () {
      this.$refs.childApplication.openFileModelStudents()
    },
    importObjectives: function (event) { // test.vue
      this.$refs.childApplication.importObjectivesMenu(event)
    },
    uploadFile: function () { // test.vue
      this.$refs.childApplication.uploadFileMenu()
    },
    enterResultsMenu: function () {
      this.$refs.childApplication.enterResultsMenu()
    },
    printReport: function () {
      this.$refs.childApplication.printReportMenu()
    },
    enterBaremeMenu: function () {
      this.$refs.childApplication.enterBaremeMenu()
    },
    gotoKnowledgeManagement: function () {
      this.$router.push({ path: '/managementKnowledge/' + this.$route.params.testId })
    },
    gotoStudentManagement: function () {
      this.$router.push({ path: '/managementStudentsGroups' })
    },
    back: function () {
      this.$refs.childApplication.back()
    },
    addStudent: function () {
      this.$refs.childApplication.addStudent()
    },
    showAddTest: function () {
      this.$refs.childApplication.showAddTest()
    },
    addCenter: function () {
      this.$refs.childApplication.addCenter()
    },
    addDiscipline: function () {
      this.$refs.childApplication.addDiscipline()
    },
    addTeacher: function () {
      this.$refs.childApplication.addTeacher()
    },
    support: function () {
      this.$router.push({ path: '/support' })
    },
    printStudentGrade: function () {
      this.$refs.childApplication.printStudentGradeMenu()
    },
    printGroupFormation: function () {
      this.$refs.childApplication.printGroupFormationMenu()
    },
    printComments: function () {
      this.$refs.childApplication.printCommentsMenu()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?7ed54316